import { createContext } from 'react'

import { IValidationContextFields } from '../models/IValidationContext'

export const ValidationContext = createContext<IValidationContextFields>({ validationResult: [] })
